<template>
  <div><zdgllb /></div>
</template>

<script>
// 获取接口地址
import zdgllb from '@/components/zdgl/zdgllb'

export default {
  name: 'Adgl',
  components: {
    // sideMenu,
    // Header
    zdgllb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
